// extracted by mini-css-extract-plugin
export default {"title":"select-card_title__zjf-+","desc":"select-card_desc__yuiR5","subtitle":"select-card_subtitle__DRyPe","card":"select-card_card__73XFF","loading":"select-card_loading__7ZNz2"};